export default __webpack_public_path__ + "static/media/mappin-green.89501874.svg";